export const clearEmailToken = () => {
    localStorage.removeItem('email');
}

export const clearAccessToken = () => {
    localStorage.removeItem('token');
}